import { RootState } from '@/state/store';

const createAssessment = (state: RootState) => state.assessment.createAssessment.entities;

const createAssessmentStatus = (state: RootState) => state.assessment.createAssessment.fetchStatus;

const fetchAssessmentFormValue = (state: RootState) => state.assessment.assessmentFormValue.assessmentFormValue;

const fetchPersonalInfoDetailValue = (state: RootState) => state.assessment.personalInfoValue.detail;

export default {
  createAssessment,
  createAssessmentStatus,
  fetchAssessmentFormValue,
  fetchPersonalInfoDetailValue,
};
